<template>
  <div id="agreement-container" class="pb-2 mt-5">
    <h1>{{ $t("utils.spaces.agreement.title") }}</h1>
    <div id="user" class="mt-4">
      <div v-html="$t('utils.spaces.agreement.data')"></div>
      <h5 v-if="!isEdit">{{ $t("utils.legal.agreed") }}</h5>
      <label class="control-agree control-checkbox-agree" v-if="isEdit">
        {{ $t("utils.legal.agree") }}*
        <input type="checkbox" v-model="info.agreeUser" />
        <div class="control_indicator-agree"></div>
      </label>
    </div>
    <div id="security" class="mt-5">
      <div v-html="$t('utils.spaces.agreement.security')"></div>
      <h5 v-if="!isEdit">{{ $t("utils.legal.agreed") }}</h5>
      <label class="control-agree control-checkbox-agree" v-else>
        {{ $t("utils.legal.agree") }}*
        <input type="checkbox" v-model="info.agreeSecurity" />
        <div class="control_indicator-agree"></div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: ["info", "isEdit"]
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/fonts";

#agreement-container {
  h1 {
    font-family: $worksans;
    font-style: normal;
    font-weight: 600;
    font-size: 24.22px;
    line-height: 38px;
    color: #161616;
  }

  p {
    font-family: $worksans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #161616;
  }

  h5 {
    font-family: $inter;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #04b900;
  }

  .control-agree {
    display: block;
    position: relative;
    padding-left: 2rem;
    margin-bottom: 0.6rem;
    padding-top: 0.2rem;
    cursor: pointer;
    font-family: $inter;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #000000;

    input {
      position: absolute;
      z-index: -1;
      opacity: 0;

      &:checked ~ .control_indicator-agree {
        background: #7e4ee2;
      }

      &:checked ~ .control_indicator-agree:after {
        display: block;
      }

      &:hover ~ .control_indicator-agree {
        border: 2px solid #7e4ee2;
      }

      &:disabled ~ .control_indicator-agree {
        background: #111112;
        opacity: 0.6;
        pointer-events: none;
      }
    }
  }

  .control_indicator-agree {
    position: absolute;
    top: 2px;
    left: 0;
    height: 22px;
    width: 22px;
    background: #fff;
    border: 2px solid #757575;
    box-sizing: border-box;
    border-radius: 4px;

    &:after {
      box-sizing: unset;
      content: "";
      position: absolute;
      display: none;
    }
  }

  .control-checkbox-agree {
    .control_indicator-agree:after {
      left: 7px;
      top: 3px;
      width: 3px;
      height: 7px;
      border: solid #fff;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }

    input:disabled ~ .control_indicator-agree:after {
      border-color: #757575;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/info/components/Agreement.vue